import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { WebkitService } from '@app/event/speech-engines/webkit/webkit.service';
import { mergeMap, switchMap, takeUntil, tap } from 'rxjs/operators';
import { EventService } from '@app/event/event.service';
import { RoutingService } from '@app/routing.service';
import { GoogleService } from '@app/event/speech-engines/google/google.service';
import { Select } from '@ngxs/store';
import { InputDevice, SettingsState } from '@app/shared/settings/settings.state';
import { Socket } from 'ngx-socket-io';
import { UserService } from '@app/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class SpeechService {
  stopRecording$: Subject<any> = new Subject<any>();
  isRecording$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  @Select(SettingsState.defaultInput) defaultInput: Observable<InputDevice>;
  pingInterval;

  constructor(
    private webkitService: WebkitService,
    private eventService: EventService,
    private routingService: RoutingService,
    private googleService: GoogleService, private socket: Socket,
    private userService: UserService
  ) {

    this.isRecording$.next(false);
  }

  startRecording = (service = 'webkit', language?: string) => {
    this.stopRecording();
    this.isRecording$.next(true);
    const serviceToMethodMap = {
      webkit: () => this.startRecordingWebkit(language),
      google: () => this.startRecordingGoogle(language),
      watson: () => this.startRecordingGoogle(language),
      deepgram: () => this.startRecordingGoogle(language),
      transcribe: () => this.startRecordingGoogle(language),
      speechmatics: () => this.startRecordingGoogle(language)
    };
    serviceToMethodMap[service]();
    this.startPinging();

  };

  startPinging() {
    console.log('startPinging');
    this.pingInterval = setInterval(() => {
      console.log('ping')
      this.socket.emit('event.heartbeat', { shortId: this.eventId, userId: this.userService._currentUser.id });
    }, 2_000);
  }

  stopPinging() {
    clearInterval(this.pingInterval);
  }

  get eventId() {
    return this.routingService.eventId;
  }

  startRecordingWebkit(language: string) {
    // Append text implicitly "starts" the event
    // This is a hack to "start" the event in order to duckpatch in the heartbeat functionality.
    this.eventService.appendText(this.eventId, null);
    console.log(language);

    this.webkitService
      .startListening$(language)
      .pipe(
        takeUntil(this.stopRecording$),
        // tap(console.log),

        mergeMap(words =>
          this.eventService.appendText(this.eventId, words)
        )
      )
      .subscribe();
  }

  startRecordingGoogle(language: string) {
    if (language) {
      this.googleService.language = language;
    }
    this.googleService
      .startListening$(this.eventId)
      .pipe(takeUntil(this.stopRecording$))
      .subscribe();
  }

  stopRecording(finalize: boolean = true) {
    // @ts-ignore
    if (window?.recorder?.state !== 'inactive') {
      // @ts-ignore
      window?.recorder?.stop();
    }
    this.stopPinging();
    this.googleService.suppressFinalization = !finalize;
    this.stopRecording$.next(null);
    this.stopRecording$.complete();
    this.stopRecording$ = new Subject<any>();
    this.isRecording$.next(false);
  }

  bypassRecording() {
    this.googleService.bypass = true;
  }

  unbypassRecording() {
    this.googleService.bypass = false;
  }
}
